import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { OrganizationStructuredDataStateDTO } from '@repo/shared/dtos/beneficiary'

import { AsyncThunkConfig, RejectValue } from '../actions'

export const getBeneficiariesStructuredDataState = createAsyncThunk<
  OrganizationStructuredDataStateDTO,
  void,
  AsyncThunkConfig
>(
  'GET_BENEFICIARIES_STRUCTURED_DATA_STATE',
  async (_, { extra, fulfillWithValue, rejectWithValue, getState }) => {
    const { altApi } = extra
    const organizationId = getState().user.currentOrganizationId
    if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)
    const res = await altApi.beneficiaries.getAllStructuredDataCurrentState({
      organizationId,
    })
    if (hasError(res)) return rejectWithValue(handleError(res))
    return fulfillWithValue(res)
  },
)

export const refreshBeneficiariesStructuredData = createAsyncThunk<
  { success: true },
  void,
  AsyncThunkConfig
>(
  'REFRESH_BENEFICIARIES_STRUCTURED_DATA',
  async (_, { extra, fulfillWithValue, rejectWithValue, getState }) => {
    const { altApi } = extra
    const organizationId = getState().user.currentOrganizationId
    if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)
    const res = await altApi.beneficiaries.refreshAllStructuredData({
      organizationId,
    })
    if (hasError(res)) return rejectWithValue(handleError(res))
    return fulfillWithValue(res)
  },
)
